import type { DataTableLoadState } from "./DataTableShell";

/**
 * DataTable load state for a list query: loading until the first result, then
 * the error (with retry) if it failed, otherwise ready (`undefined`).
 */
export function queryLoadState({
  isLoading,
  error,
  errorMessage,
  retryLabel,
  onRetry,
}: {
  isLoading: boolean;
  error: unknown;
  errorMessage: string;
  retryLabel: string;
  onRetry: () => void;
}): DataTableLoadState | undefined {
  if (isLoading) return { status: "loading" };
  if (error) {
    return { status: "error", message: errorMessage, retryLabel, onRetry };
  }
  return undefined;
}
